import gql from 'graphql-tag';

export const getPayjp3dSecureCallbackUrl = gql`
  query getPayjp3dSecureCallbackUrl($input: Payjp3dSecureCallbackUrlInput) {
    getPayjp3dSecureCallbackUrl(input: $input) {
      url
    }
  }
`;
